import { Input, Text, InputGroup } from '@chakra-ui/react';
import { useField } from 'formik';
import { useRef } from 'react';
import { colors } from '@/theme/foundations/colors';
import { currencyFormatterHelpers } from '@/utils/currencyFormatter';

const { formatCurrencyNumber, cleanCurrencyInput } = currencyFormatterHelpers;

export const PlainInput = ({ item = {}, field, formik }) => {
  const {
    name,
    inputType,
    isEditable = true,
    placeholder = '',
    label,
    styles,
    maxLength,
    disabled,
    inputRef,
    formatType,
    currencyFieldName,
    minValue = 0,
    maxValue,
    isInputSubmit = false,
    customValidation,
  } = item;

  const [helpers] = useField(name);
  const { setTouched, setValue } = helpers || {};

  const [, currencyMeta] = useField(
    currencyFieldName || 'dummy_currency_field'
  );
  const selectedCurrencyId = currencyFieldName ? currencyMeta?.value : null;

  const localInputRef = useRef();
  if (!item) return null;

  const formatNumberWithCommas = (value) => {
    if (!value) return '';
    const numericValue = value?.split('.')[0].replace(/[^\d]/g, '');
    return numericValue?.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  const getSelectedCurrencyString = () => {
    if (!currencyFieldName || !selectedCurrencyId || !item.currencies)
      return null;

    const selectedCurrency = item.currencies.find(
      (c) => c.id === selectedCurrencyId
    );
    return selectedCurrency?.currency || null;
  };

  const formattedValue = (() => {
    if (formatType === 'currency') {
      const currencyString = getSelectedCurrencyString();
      if (currencyString && currencyFieldName) {
        return formatCurrencyNumber(field?.value || '', currencyString);
      }
      return formatNumberWithCommas(field?.value || '');
    }
    return field?.value || '';
  })();

  const handleOnChange = (event) => {
    const val = event.target.value;

    if (customValidation) {
      customValidation(val, event, field?.onChange);
    } else if (formatType !== 'currency') {
      field?.onChange(event);
    } else {
      const cleanedValue = cleanCurrencyInput(val);
      setValue(cleanedValue);
    }
  };

  let MaxLengthElement;
  if (maxLength) {
    MaxLengthElement = () => {
      return (
        <Text pt="13px" color="#7E7E7E" size="sm-medium" pr="5px">
          {field?.value?.length || 0}/{maxLength}
        </Text>
      );
    };
  }

  return (
    <InputGroup
      w="100%"
      border={'1px solid '}
      borderColor={colors['border-color']}
      borderRadius="sm"
    >
      <Input
        {...field}
        onChange={handleOnChange}
        onClick={() => {
          if (inputRef?.current) {
            inputRef.current?.focus();
          } else if (localInputRef?.current) {
            localInputRef.current?.focus();
          }
        }}
        ref={inputRef || localInputRef}
        id={name}
        variant="ats-input-variant-2"
        autoComplete="off"
        _placeholder={{
          opacity: 1,
          fontSize: '12px',
        }}
        _hover={{
          outline: 'none !important',
          border: 'none!important',
          boxShadow: 'none !important',
        }}
        _focus={{
          outline: 'none !important',
          border: 'none !important',
          boxShadow: 'none !important',
        }}
        type={inputType || 'text'}
        disabled={disabled || !isEditable}
        value={formattedValue}
        placeholder={placeholder || `Enter ${label?.toLowerCase()}`}
        maxLength={maxLength}
        min={minValue}
        max={maxValue}
        onFocus={() => setTouched && setTouched(false)}
        onBlur={() => setTouched && setTouched(true)}
        background={'none'}
        onKeyDown={(e) => {
          if (e.key === 'Enter') {
            e.preventDefault();
            if (formik && isInputSubmit) {
              formik.submitForm();
            }
          }
        }}
        {...styles}
      />
      {MaxLengthElement && <MaxLengthElement />}
    </InputGroup>
  );
};
